import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Button from '@softwaredev_cegeka/stix-core/dist/components/Button'

import styles from './radioCheckmark.module.scss'
// TODO remove this after refactoring the translations selector.
export default class RadioCheckmark extends Component {
    static propTypes = {
        checked: PropTypes.bool.isRequired,
        label: PropTypes.string.isRequired,
        loading: PropTypes.bool,
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        onSecondaryAction: PropTypes.func,
        secondaryActionIcon: PropTypes.string,
        value: PropTypes.string,
    }

    render() {
        const {
            checked,
            className,
            label,
            loading,
            name,
            onChange,
            onSecondaryAction,
            secondaryActionIcon,
            value,
            ...rest
        } = this.props

        return (
            <label
                className={cx(styles.container, className, {
                    [styles.isActive]: checked,
                })}
                {...rest}
            >
                <input
                    type="radio"
                    name={name}
                    checked={checked}
                    onChange={onChange}
                    value={value}
                />
                <span className={styles.checkmark}></span>
                {label}
                {secondaryActionIcon ? (
                    <Button
                        className={styles.clearSelectionButton}
                        disabled={loading}
                        variant="naked"
                        onClick={onSecondaryAction}
                    >
                        <FontAwesomeIcon
                            icon={secondaryActionIcon}
                            spin={loading}
                        />
                    </Button>
                ) : null}
            </label>
        )
    }
}
